import { action } from 'typesafe-actions';
import { ResponseError } from '../../../services/api';
import { Banner, BannerTypes } from './types';

export const loadRequest = () => action(BannerTypes.LOAD_REQUEST);
export const loadSuccess = (data: Banner[]) => action(BannerTypes.LOAD_SUCCESS, { data });
export const loadFailure = (error: ResponseError) => action(BannerTypes.LOAD_FAILURE, { error });
